import 'scss/solutions/data-center.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/data-center.js